import React from "react";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export const VideoCard = (props) => {
  const { keyValue, videoId, image, videoTitle, time } = props;

  const history = useHistory();
  const handleClick = (id) => {
    history.push(`/video/${id}`);
  };

  return (
    <Card
      sx={{
        maxWidth: 345,
        backgroundColor: "#181818",
        boxShadow: 0,
        borderRadius: 0,
      }}
      id={videoId}
      onClick={() => handleClick(videoId)}
      key={keyValue}
    >
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={image}
          alt="green iguana"
        />

        <Typography
          gutterBottom
          fontSize="14px"
          component="div"
          color="#FFFFFF"
          fontWeight="700"
          paddingTop="5px"
        >
          {videoTitle}
        </Typography>
        <Typography
          fontSize="14px"
          color="#D1D5DA"
          fontWeight="400"
          // paddingTop="5px"
        >
          {props.time < 12
            ? `${time} Months`
            : `${Math.round(time / 12)} Years`}
        </Typography>
      </CardActionArea>
    </Card>
  );
};
